import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { v4 as uuid } from 'uuid';
import { NavItem } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { get } from 'lodash';
import { ContextMenu, MenuItem, ContextMenuTrigger } from 'react-contextmenu';
import { SECTION_ITEM_TYPES, PARTICIPANT_ROLES, LEARNING_ASSET_TYPES } from '../../../../../shared/Constants';
import { countArrInstances } from '../../../../../shared/utils/ArrayUtils';

export const sectionItemTypeIcons = {
    '': '',
    [SECTION_ITEM_TYPES.SURVEY_CONTENT]: 'fal fa-star',
    [SECTION_ITEM_TYPES.EMAIL_NUDGE]: 'fal fa-envelope',
    [SECTION_ITEM_TYPES.SHORT_ESSAY_CONTENT]: 'fal fa-pencil-alt',
    [SECTION_ITEM_TYPES.LIKERT_CONTENT]: 'fal fa-sliders-h',
    [SECTION_ITEM_TYPES.THIS_OR_THAT_PERMUTATION_CONTENT]: 'fal fa-columns',
    [SECTION_ITEM_TYPES.THIS_OR_THAT_RESULTS_CONTENT]: 'fal fa-balance-scale',
    [SECTION_ITEM_TYPES.CHOOSE_MANY_CONTENT]: 'fal fa-check-square',
    [SECTION_ITEM_TYPES.CHOOSE_ONE_CONTENT]: 'fal fa-check-circle',
    [SECTION_ITEM_TYPES.ONSCREEN_NUDGE]: 'fal fa-laptop',
    [SECTION_ITEM_TYPES.RANKING_CONTENT]: 'fal fa-list-ol',
    [SECTION_ITEM_TYPES.RICH_TEXT_CONTENT]: 'fal fa-address-card',
    [SECTION_ITEM_TYPES.DYNAMIC_RICH_TEXT_CONTENT]: 'fal fa-address-card',
    [SECTION_ITEM_TYPES.USER_INVITE_CONTENT]: 'fal fa-envelope fa-fw',
    [SECTION_ITEM_TYPES.CHOOSE_ONE_RESULTS_CONTENT]: 'fal fa-list-ol',
    [SECTION_ITEM_TYPES.THIS_OR_THAT_RESULTS_CHART]: 'fal fa-chart-area',
    [SECTION_ITEM_TYPES.SHORT_ESSAY_RESULT]: 'fal fa-list',
    [SECTION_ITEM_TYPES.FILE_UPLOAD_CONTENT]: 'fal fa-upload',
    [SECTION_ITEM_TYPES.CHOOSE_ONE_QUIZ]: 'fal fa-check-circle',
    [SECTION_ITEM_TYPES.QUIZ_RESULTS]: 'fal fa-check-circle',
    [SECTION_ITEM_TYPES.SHOW_PREVIOUS_ANSWERS]: 'fal fa-th-list',
    [SECTION_ITEM_TYPES.FEEDBACK_CONTENT]: 'fal fa-bullhorn',
    [SECTION_ITEM_TYPES.FEEDBACK_WRAPUP]: 'fal fa-anchor',
    [SECTION_ITEM_TYPES.FEEDBACK_INVITE]: 'fal fa-envelope',
    [SECTION_ITEM_TYPES.END_SESSION_CONTENT]: 'fal fa-handshake',
    [SECTION_ITEM_TYPES.REVIEW_PREV_ACTIVITIES]: 'fal fa-layer-group',
    [SECTION_ITEM_TYPES.WRAP_UP]: 'fas fa-check',
    [SECTION_ITEM_TYPES.SHOW_PREVIOUS_ANSWERS_CHOOSE_ONE]: 'far fa-digital-tachograph',
    [SECTION_ITEM_TYPES.CHOOSE_ONE_PATH_CONTENT]: 'fal fa-code-branch'
};

const sectionItemDefaults = {
    name: '',
    type: 'Dynamic Rich Text',
    minutes: 0,
    isActive: true,
    isVisible: false,
    dataScope: 'solo',
    startsOn: 1,
    startsAfter: 'start',
    transition: 'fade',
    targetParticipantRole: 'all'
};

class RenderSectionItems extends Component {
    static propTypes = {
        fields: PropTypes.any,
        type: PropTypes.oneOf([
            LEARNING_ASSET_TYPES.TRACK,
            LEARNING_ASSET_TYPES.ACTIVITY,
            LEARNING_ASSET_TYPES.ARTICLE,
            LEARNING_ASSET_TYPES.VIDEO,
            LEARNING_ASSET_TYPES.IMPACT_PROJECT,
            LEARNING_ASSET_TYPES.SINGLE_PAGE_ACTIVITY,
            LEARNING_ASSET_TYPES.ASSESSMENT,
            LEARNING_ASSET_TYPES.PRE_ASSESSMENT,
            LEARNING_ASSET_TYPES.POST_ASSESSMENT,
            LEARNING_ASSET_TYPES.FEEDBACK,
            LEARNING_ASSET_TYPES.MOBILE,
            LEARNING_ASSET_TYPES.PRACTICAL_APPLICATION,
            LEARNING_ASSET_TYPES.REFLECTION
        ]),
        sectionId: PropTypes.string,
        selectedSectionItemId: PropTypes.string,
        basePath: PropTypes.string,
        reviewItems: PropTypes.object,
        changeFormValue: PropTypes.func,
        currentFormValues: PropTypes.object,
        sectionItemSelected: PropTypes.func.isRequired
    };

    _getFormValue(fieldName) {
        return get(this.props.currentFormValues, fieldName, '');
    }

    _createNewSectionItem = (sectionId, sectionItemDefaults) => {
        const newItemId = uuid();
        this.props.fields.push({ id: newItemId, sectionId, ...sectionItemDefaults });
        this.props.sectionItemSelected(sectionId, newItemId);
    };

    /**
     * Checks to see if the add sectionItem button should be disabled
     * @return {boolean}
     * @private
     */
    _isAddSectionItemButtonDisabled = () => {
        const { type, fields } = this.props;

        const fieldsLength = get(fields, 'length', 0);
        if (type === LEARNING_ASSET_TYPES.ACTIVITY && fieldsLength >= 30) {
            return true;
        }
        if (type === LEARNING_ASSET_TYPES.FEEDBACK && fieldsLength >= 15) {
            return true;
        }
        return false;
    };

    _copyField = (itemIndex, sectionIndex, section) => {
        const { fields, changeFormValue } = this.props;

        const newSectionItem = { ...fields.get(itemIndex) };
        newSectionItem.id = uuid();
        newSectionItem.sectionId = section.id;

        const sectionItemIndex = section.sectionItems.length;
        changeFormValue({
            field: `sections[${sectionIndex}].sectionItems[${sectionItemIndex}]`,
            value: newSectionItem
        });
    };

    render() {
        const {
            fields,
            selectedSectionItemId,
            sectionId,
            sectionItemSelected,
            currentFormValues,
            reviewItems = {},
            basePath
        } = this.props;

        let copyContextMenuItems = <span />;

        const renderedSectionItems = fields.map((member, index) => {
            const currentSectionId = this._getFormValue(`${member}.sectionId`);
            if (currentSectionId !== sectionId) {
                return null;
            }
            const sectionItemId = this._getFormValue(`${member}.id`);
            const sectionItemType = this._getFormValue(`${member}.type`);
            const isVisible = this._getFormValue(`${member}.isVisible`);
            const sectionItemName = this._getFormValue(`${member}.name`);
            const isActive = this._getFormValue(`${member}.isActive`);
            const isReferenceGuideItem = this._getFormValue(`${member}.isIncludedInDiscussionGuide`);

            if (currentFormValues) {
                copyContextMenuItems = get(currentFormValues, 'sections', []).map((section, i) => (
                    <MenuItem
                        key={`menuItem-${section.id}-${sectionItemId}`}
                        onClick={() => this._copyField(index, i, section)}
                    >
                        Copy to {section.name}
                    </MenuItem>
                ));
            }
            const formattedSectionItemType = (sectionItemType || '').toLocaleUpperCase();
            const targetedParticipantRole = (
                this._getFormValue(`${member}.targetParticipantRole`) || ''
            ).toLocaleUpperCase();

            const isEmployeeTargeted = targetedParticipantRole === PARTICIPANT_ROLES.EMPLOYEE;
            const isSIOTargeted = targetedParticipantRole === PARTICIPANT_ROLES.SOCIAL_ENTREPRENEUR;

            const commentCount = countArrInstances(reviewItems[sectionItemId], (item) => item.status === 'OPEN');

            return (
                <div
                    key={index}
                    onClick={() => sectionItemSelected(sectionId, sectionItemId)}
                    className={cns(
                        'trackSectionItem',
                        { active: sectionItemId === selectedSectionItemId },
                        { isVisible }
                    )}
                >
                    <ContextMenuTrigger id={`sectionItem-${sectionItemId}`}>
                        <div className={'col-10'}>
                            <div className={'row'}>
                                <div className={'col-10'}>
                                    <i
                                        className={cns(
                                            'icon',
                                            'fa-fw',
                                            isActive ? 'fa' : 'fal',
                                            sectionItemTypeIcons[formattedSectionItemType],
                                            { sioTargeted: isSIOTargeted },
                                            { employeeTargeted: isEmployeeTargeted },
                                        )}
                                    />
                                    <span style={{ marginLeft: '5px', marginRight: '5px' }}>{sectionItemName}</span>
                                    {isReferenceGuideItem && <i className={cns('icon', 'far fa-list-alt')} />}
                                </div>
                                <div className={'col-2 asset-comment-count-container'}>
                                    {reviewItems[sectionItemId] ? (
                                        <div className={'asset-comment-count'}>
                                            <NavItem>
                                                <NavLink to={`${basePath}/comments/${sectionItemId}`}>
                                                    {`${commentCount}  `}
                                                    <i className={cns('fa', 'fa-comment', { closed: !commentCount })} />
                                                </NavLink>
                                            </NavItem>
                                        </div>
                                    ) : (
                                        ''
                                    )}
                                </div>
                            </div>
                        </div>
                    </ContextMenuTrigger>
                    <ContextMenu id={`sectionItem-${sectionItemId}`}>{copyContextMenuItems}</ContextMenu>
                </div>
            );
        });

        return (
            <div>
                <div className={'trackSection'}>{renderedSectionItems}</div>
                <h4 className={'trackSectionItemTitle'}>
                    <i
                        disabled={this._isAddSectionItemButtonDisabled()}
                        onClick={() => this._createNewSectionItem(sectionId, sectionItemDefaults)}
                        className={'icon addSectionItem fa fa-plus fa-mini'}
                    />
                    <span style={{ marginLeft: '5px' }}>Add Section Item</span>
                </h4>
            </div>
        );
    }
}

export default RenderSectionItems;
